import script from "./ButtonCompVue.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonCompVue.vue?vue&type=script&setup=true&lang=js"

import "./ButtonCompVue.vue?vue&type=style&index=0&id=7266cac0&lang=scss&scoped=true"

import exportComponent from "../../fin_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7266cac0"]])

export default __exports__